/* eslint-disable */
export default {
  cancel: '取消',
  pmiChangeConfirmed: '變更',
  pmiChangeConfirmTitle: '確定要變更個人會議設定？',
  pmiChangeConfirmContext:
    '變更這些設定會影響使用您個人會議 ID 或名稱的所有會議，包含已排定的會議',
  updatePassword: '更新密碼',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"pmiChangeConfirmed"@#@ @source: @#@"Change"@#@
// @key: @#@"pmiChangeConfirmTitle"@#@ @source: @#@"Change Personal Meeting settings?"@#@
// @key: @#@"pmiChangeConfirmContext"@#@ @source: @#@"Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"@#@
// @key: @#@"updatePassword"@#@ @source: @#@"Update password"@#@
